import request from "@/utils/request.js";

// 事件分析_处理状态
export const analyseeventstatus = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/status",
    params: data || {}
  });
};
// 事件分析_响应时间
export const analyseeventdiffTimeType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/diffTimeType",
    params: data || {}
  });
};
// 事件分析_事件类型
export const analyseeventtype = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/type",
    params: data || {}
  });
};
// 事件分析_趋势统计
export const analyseeventdataCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/dataCount",
    params: data || {}
  });
};
// 事件分析_区域统计
export const analyseeventregion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/region",
    params: data || {}
  });
};
// 事件分析_解决数量
export const analyseeventdoneCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/doneCount",
    params: data || {}
  });
};

// 事件分析_事件总数
export const analysecount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/count",
    params: data || {}
  });
};
